import React, { useEffect, useState, useCallback } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { Link, useParams } from 'react-router-dom';
import { db } from '../../../firebase';

import Loading from '../../Loading';

import styleClasses from '../css/mobile/Contact.module.scss';

const Contact = () => {
  const { id: musicianId } = useParams(); // URL에서 musicianId 가져오기
  const [musicianInfo, setMusicianInfo] = useState(null); // 개인 정보
  const [locations, setLocations] = useState([]); // 위치 정보
  const [loading, setLoading] = useState(true); // 로딩 상태

  const fetchContactData = useCallback(async () => {
    try {
      // Fetch personal info
      const personalDocRef = doc(db, 'musicians', musicianId, 'contact', 'personal');
      const personalSnapshot = await getDoc(personalDocRef);
      let personalData = personalSnapshot.data();

      // Convert sns map to an array
      if (personalData.sns && typeof personalData.sns === 'object') {
        personalData.sns = Object.entries(personalData.sns).map(([platform, url]) => ({
          platform,
          url,
        }));
      } else {
        personalData.sns = [];
      }

      // Convert musicLinks map to an array
      if (personalData.musicLinks && typeof personalData.musicLinks === 'object') {
        personalData.musicLinks = Object.entries(personalData.musicLinks).map(([platform, url]) => ({
          platform,
          url,
        }));
      } else {
        personalData.musicLinks = [];
      }

      // Fetch location info
      const locationDocRef = doc(db, 'musicians', musicianId, 'contact', 'location');
      const locationSnapshot = await getDoc(locationDocRef);

      let locationData = [];
      if (locationSnapshot.exists()) {
        locationData = Object.values(locationSnapshot.data()); // 데이터를 배열로 변환
      }

      // Update state
      setMusicianInfo(personalData);
      setLocations(locationData);
    } catch (error) {
      console.error('Error fetching contact data:', error);
    } finally {
      setLoading(false);
    }
  }, [musicianId]);

  useEffect(() => {
    if (musicianId) {
      fetchContactData(); // 뮤지션 ID로 데이터 가져오기
    }
  }, [musicianId, fetchContactData]);

  return (
    loading
    ?
    <Loading />
    :
    <div className={ styleClasses.contactMobile }>
      <h2 className={ styleClasses.contactTitle }>Contact { musicianInfo.name }</h2>
      {musicianInfo.introduction && (
            <h3 className={styleClasses.contactIntro}>{musicianInfo.introduction}</h3>
      )}
      {
        !musicianInfo
        ?
        <p>No contact data available.</p>
        :
        <>
          {/* Google Maps iframe (위치 정보가 있는 경우에만 렌더링) */}
          {
            locations.length > 0 &&
            <div className={ styleClasses.mapContainer }>
              {locations.map((location, index) => (
                <div key={ index } className={ styleClasses.location }>
                  <iframe
                    src={`https://www.google.com/maps?q=${ location.lat },${ location.lng }&z=15&output=embed`}
                    allowFullScreen=""
                    loading="lazy"
                    title={`Location ${ index + 1 }`}
                  ></iframe>
                  <p className={ styleClasses.region }>{location.placeName || location.region}</p>
                </div>
              ))}
            </div>
          }

          {/* SNS 및 포트폴리오 링크 */}
          <div className={ styleClasses.socialLinks }>
            {musicianInfo.email && (
              <Link to={`mailto:${ musicianInfo.email }`} className={ styleClasses.socialLink }>
                <svg xmlns="http://www.w3.org/2000/svg" className={ styleClasses.socialIcon } width="36" height="36" viewBox="0 0 24 24">
                  <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4.7-8 5.334L4 8.7V6.297l8 5.333 8-5.333V8.7z"></path>
                </svg>
                <span className={ styleClasses.platformName }>{ musicianInfo.email }</span>
                <div className={ styleClasses.backgroundLink }></div>
              </Link>
            )}
            {
              musicianInfo && musicianInfo.sns.length > 0 &&
              musicianInfo.sns.map((link, index) => (
                <Link
                  key={ index }
                  to={ link.url }
                  target="_blank"
                  rel="noopener noreferrer"
                  className={ styleClasses.socialLink }
                >
                  <img
                    src={`/assets/icons/${ link.platform.toLowerCase().replace(/ /g, '_') }-icon_1.png`}
                    alt={ link.platform }
                    className={ styleClasses.socialIcon }
                    onError={(e) => {
                      e.target.onerror = null; // 무한루프 방지
                      e.target.src = "/assets/icons/etc-icon_1.png"; // fallback 이미지
                    }}
                  />
                  <span className={ styleClasses.platformName }>{ link.platform }</span>
                  <div className={ styleClasses.backgroundLink }></div>
                </Link>
              ))
            }
            {
              musicianInfo && musicianInfo.musicLinks.length > 0 &&
              musicianInfo.musicLinks.map((link, index) => (
                <Link
                  key={ index }
                  to={ link.url }
                  target="_blank"
                  rel="noopener noreferrer"
                  className={ styleClasses.socialLink }
                >
                  <img
                    src={`/assets/icons/${ link.platform.toLowerCase().replace(/ /g, '_') }-icon_1.png`}
                    alt={ link.platform }
                    className={ styleClasses.socialIcon }
                    onError={(e) => {
                      e.target.onerror = null; // 무한루프 방지
                      e.target.src = "/assets/icons/etc-icon_1.png"; // fallback 이미지
                    }}
                  />
                  <span className={ styleClasses.platformName }>{ link.platform }</span>
                  <div className={ styleClasses.backgroundLink }></div>
                </Link>
              ))
            }
          </div>
        </>
      }
    </div>

  );
};

export default Contact;
